import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_FAQ } from '@app/advisor-ui-shared';
export const dispatch_onFAQUpdated = new ThunderDispatcherV3('__onFAQsUpdated');
export class ModuleFE_FAQ_Class extends ModuleFE_BaseApi {
    __searchFilterMapper = (item) => [item.label, item._id];
    __searchGroups = (items, filter) => {
        return [{
                group: this.dbDef.entityName,
                results: items.map(item => ({ _id: item._id, uiLabel: item.label }))
            }];
    };
    constructor() {
        super(DBDef_FAQ, dispatch_onFAQUpdated);
    }
}
export const ModuleFE_FAQ = new ModuleFE_FAQ_Class();
//# sourceMappingURL=ModuleFE_FAQ.js.map